import { FC, useState } from "react";
import { useTheme } from "styled-components";
import {
  HeaderThreeDropDown,
  HeaderThreeDropDownSub,
  HeaderThreeMainTabCont,
  HeaderThreeSubTabCont,
  SubListBottom2,
} from "./styled.styles";
import {
  classNames,
  labelHelper,
  trField,
  urlHelper,
} from "helpers/themeHelpers";
import { isCategoryCars, isCategoryRealEstate } from "helpers/osHelpers";
import { IMenuCollection } from "models/megaMenu";
import { gtmMegaMenuCat, gtmMegaMenuSubCat } from "GTMs/actions/homeActions";
import useGetRouteCity from "hooks/useGetRouteCity";
import {
  isCarseerAvilableinthisCountry,
  isMojazAvilableinthisCountry,
} from "componentScreens/CarReportsPage/helpers/carReportsHelper";
import {
  linkToCarfax,
  linkToCarseer,
  linkToMojaz,
} from "helpers/links-builders/carReportsLinkBuilders";

export const LevelThreeMenuItem: FC<{
  category: IMenuCollection;
  className?: string;
}> = ({ category, className }) => {
  const city = useGetRouteCity();
  const city_url = city ? `${urlHelper(city)}/` : "";
  const { locale, translations, country } = useTheme();
  const isRealEstate = category && category.reporting_name === "RealEstate";
  const [isMouseOver, setIsMouseOver] = useState(false);

  const handleMouseOver = () => {
    // Update the state to indicate that the mouse is out
    setIsMouseOver(true);
  };
  const handleMouseOut = () => {
    // Update the state to indicate that the mouse is out
    setIsMouseOver(false);
  };

  function goToAll(event) {
    event.preventDefault();
    const href = event.target.getAttribute("href");
    document.location.href = href + "/all";
  }

  return (
    <HeaderThreeMainTabCont data-attr="hover" className="relative">
      <a
        href={`/${locale}/${city_url}${
          trField(category, "standalone") || urlHelper(category)
        }`}
        {...classNames(
          "bold block relative whiteColor font-17 p-8 megaMenuSource",
          isMouseOver && "openFirstChild"
        )}
        onClick={() => gtmMegaMenuCat(category?.reporting_name)}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
      >
        {labelHelper(category)}
      </a>
      <HeaderThreeDropDown
        {...classNames(
          "headerThreeDropDown whiteBg font-14 absolute p-8 pt-0 pe-0 ",
          className,
          className === "lastTwoMenus" && "ps-0",
          className !== "lastTwoMenus" && "pe-0",
          isCategoryCars(category) && "autosSubList",
          !isCategoryCars(category) && "realEstateSubList"
        )}
      >
        {/********************************************************/}
        {category &&
          category.subCategories.map((subCat, i) => (
            <HeaderThreeSubTabCont
              key={i}
              data-attr="hover"
              {...classNames(
                "megaMenuSource megaMenuLogging",
                subCat?.cps?.length === 0 && "noCps"
              )}
            >
              <a
                href={
                  "/" +
                  [
                    locale,
                    urlHelper(city),
                    urlHelper(category),
                    urlHelper(subCat),
                  ]
                    .filter(Boolean)
                    .join("/")
                }
                {...classNames(
                  "block border-8 blackColor grayHoverBg hoverSubCat p-8"
                )}
                data-catrepname={category?.reporting_name}
                data-subcat-repname={subCat?.reporting_name}
                onClick={(e) => {
                  gtmMegaMenuSubCat(
                    category?.reporting_name,
                    subCat?.reporting_name
                  );
                  goToAll(e);
                }}
              >
                {labelHelper(subCat)}
              </a>
              {subCat?.cps.length !== 0 && (
                <HeaderThreeDropDownSub
                  {...classNames(
                    "headerThreeDropDownSub2 absolute overflowHidden p-16",
                    className
                  )}
                >
                  <a
                    href={
                      "/" +
                      [
                        locale,
                        urlHelper(city),
                        urlHelper(category),
                        urlHelper(subCat),
                      ]
                        .filter(Boolean)
                        .join("/")
                    }
                    onClick={() =>
                      gtmMegaMenuSubCat(
                        category?.reporting_name,
                        subCat?.reporting_name
                      )
                    }
                    className="bold width-50 borderBottom pb-8 mb-16 inline blackColor"
                  >
                    {labelHelper(subCat)}
                  </a>
                  <a
                    key={i}
                    href={`/${locale}/${city_url}${
                      urlHelper(category) ? urlHelper(category) + "/" : ""
                    }${urlHelper(subCat)}${
                      isCategoryRealEstate(category) ? "/all" : ""
                    }`}
                    className="seeAll bold width-50 borderBottom pb-8 mb-16 inline"
                    aria-label={translations.seeAll}
                  >
                    {translations.seeAll}
                  </a>
                  {/****************************************************************/}
                  {subCat?.cps?.map((item, i) => {
                    return (
                      <a
                        data-subcat-repname={subCat?.reporting_name}
                        data-catrepname={category?.reporting_name}
                        key={i}
                        href={`/${locale}/${city_url}${
                          urlHelper(category) ? urlHelper(category) + "/" : ""
                        }${urlHelper(subCat)}/${urlHelper(item)}`}
                        className="pb-16 width-50 megaMenuSource megaMenuLogging inline blackColor"
                      >
                        {labelHelper(item)}
                      </a>
                    );
                  })}

                  {/*********************************************************************/}
                  {isCategoryCars(category) && (
                    <>
                      <SubListBottom2 className="mb-8 pt-8">
                        {translations.header.servicesOpenSooq}
                      </SubListBottom2>
                      <a
                        href={linkToCarfax()}
                        className="bold float-s"
                        aria-label={translations.footer.carfax}
                      >
                        {translations.footer.carfax}
                      </a>
                      {isCarseerAvilableinthisCountry(country) ? (
                        <a
                          href={linkToCarseer()}
                          className="bold float-e"
                          aria-label={translations.footer.carseer}
                        >
                          {translations.footer.carseer}
                        </a>
                      ) : null}
                      {isMojazAvilableinthisCountry(country) ? (
                        <a
                          href={linkToMojaz()}
                          className="bold block float-e"
                          aria-label={translations.footer.mojaz}
                        >
                          {translations.footer.mojaz}
                        </a>
                      ) : null}
                    </>
                  )}
                </HeaderThreeDropDownSub>
              )}
            </HeaderThreeSubTabCont>
          ))}
        {/***********************************/}
      </HeaderThreeDropDown>
    </HeaderThreeMainTabCont>
  );
};

export const OtherCategories: FC<{
  mainCategories: IMenuCollection[];
  className: string;
}> = ({ mainCategories, className }) => {
  const { translations, locale } = useTheme();
  const city = useGetRouteCity();
  const city_url = city ? `${urlHelper(city)}/` : "";
  return (
    <HeaderThreeMainTabCont data-attr="hover" className="relative">
      <div className="otherMenu bold relative whiteColor font-17 pointer megaMenuSource p-8">
        {translations.header.otherCategories}
      </div>
      <HeaderThreeDropDown
        data-attr="hover"
        {...classNames(
          "headerThreeDropDown whiteBg font-14 absolute p-8 pt-0",
          className === "lastTwoMenus" && "ps-0",
          className !== "lastTwoMenus" && "pe-0"
        )}
      >
        {mainCategories?.map((mainCat, index) => {
          return (
            <HeaderThreeSubTabCont
              key={index}
              data-attr="hover"
              className="megaMenuSource"
            >
              <a
                href={`/${locale}/${city_url}${urlHelper(mainCat)}`}
                {...classNames(
                  "block border-8 blackColor grayHoverBg hoverSubCat p-8"
                )}
                onClick={() => gtmMegaMenuCat(mainCat?.reporting_name)}
              >
                {labelHelper(mainCat)}
              </a>
              <HeaderThreeDropDownSub
                {...classNames(
                  "headerThreeDropDownSub2 absolute overflowHidden p-16",
                  className,
                  index == 0 && "openFirstChild"
                )}
              >
                <a
                  href={`/${locale}/${city_url}${urlHelper(mainCat)}`}
                  {...classNames(
                    "block width-100 borderBottom pb-8 mb-8 bold blackColor"
                  )}
                  onClick={() => gtmMegaMenuCat(mainCat?.reporting_name)}
                >
                  {labelHelper(mainCat)}
                </a>
                {/****************************************************************/}
                {mainCat?.subCategories?.map((subCat, i) => {
                  return (
                    <a
                      key={i}
                      href={`/${locale}/${city_url}${urlHelper(
                        mainCat
                      )}/${urlHelper(subCat)}`}
                      onClick={() =>
                        gtmMegaMenuSubCat(
                          mainCat.reporting_name,
                          subCat?.reporting_name
                        )
                      }
                      data-subcat-repname={subCat?.reporting_name}
                      data-catrepname={mainCat?.reporting_name}
                      className="pb-16 width-50 megaMenuSource megaMenuLogging inline blackColor"
                    >
                      {labelHelper(subCat)}
                    </a>
                  );
                })}
              </HeaderThreeDropDownSub>
            </HeaderThreeSubTabCont>
          );
        })}
      </HeaderThreeDropDown>
    </HeaderThreeMainTabCont>
  );
};
